import { useMemo } from 'react';

import { Box, BoxProps } from '@mui/material';

import { getTotalPropertyAmount } from '@arrived/common';
import { Offering } from '@arrived/models';

import { PropertyAmountBreakdownTitle } from './PropertyAmountBreakdownTitle';
import { PropertyAmountBreakdownValue } from './PropertyAmountBreakdownValue';

export interface PropertyAmountTotalProps extends BoxProps {
  offering: Offering;
}

const arrowSize = 20;
// Getting the distance from a corner of the square to the center.
const wrapperPb = Math.cos(Math.PI / 4) * arrowSize;

export const PropertyAmountTotal = ({ offering, ...rest }: PropertyAmountTotalProps) => {
  const totalPropertyAmount = useMemo(() => getTotalPropertyAmount(offering), [offering]);

  return (
    <Box {...rest}>
      <Box pb={`${wrapperPb}px`}>
        <Box position="relative" bgcolor={({ palette }) => palette.lightened.iceGreen} textAlign="center" p={3}>
          <Box
            bgcolor="inherit"
            position="absolute"
            bottom={0}
            left="50%"
            sx={{ transform: 'translate(-50%, 50%) rotate(45deg)', transformOrigin: 'center' }}
            width={`${arrowSize}px`}
            height={`${arrowSize}px`}
          />
          <PropertyAmountBreakdownTitle
            formattedMessageProps={{ id: 'property-amount-total', defaultMessage: 'Total Property Amount' }}
            tooltipMessageProps={{
              id: 'property-amount-total-tooltip',
              defaultMessage: 'The total costs for the property, improvements, cash reserve, and fees.',
            }}
          />
          <PropertyAmountBreakdownValue value={totalPropertyAmount} />
        </Box>
      </Box>
    </Box>
  );
};
